import { render, staticRenderFns } from "./IconsMap.vue?vue&type=template&id=5fd5638a&scoped=true&"
import script from "./IconsMap.vue?vue&type=script&lang=js&"
export * from "./IconsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd5638a",
  null
  
)

export default component.exports